import ClientView from "../pages/Survey/ClientView/ClientView";
import BClientView from "../pages/Survey/ClientView/BClientView";
import {
  Summeryreport,
  CreateSurvey,
  EditBasicInfo,
  SurveyAnalytics,
  ManageFonts,
  NewThankYou,
  NewSurveySubmitted,
} from "../pages/pages";
import NewBClientView from "../pages/Survey/ClientView/NewBClientView";
export const routes = [
  { path: "/", element: <Summeryreport /> },
  { path: "/survey/summary", element: <Summeryreport /> },
  { path: "/surveycreation", element: <CreateSurvey /> },
  { path: "/surveyEdit", element: <EditBasicInfo /> },
  { path: "/surveyAnalytics", element: <SurveyAnalytics /> },
  { path: "/ClientSurveyView", element: <ClientView /> },
  { path: "/BClientSurveyView", element: <BClientView /> },
  { path: "/NBClientSurveyView", element: <NewBClientView /> },
  { path: "/manage-fonts", element: <ManageFonts /> },
  { path: "/ClientSurveyView/thankYou", element: <NewThankYou /> },
  {
    path: "/ClientSurveyView/surveySubmitted",
    element: <NewSurveySubmitted />,
  },
  {
    path: "*",
    element: <h1>Not found</h1>,
  },
];
